import axiosInstance from "./AxiosInstance";

// Login API call
export function login(username, password) {
  const token = "e532c7ba3d7dd872df0f67576c161969";
  return axiosInstance.post("/admin/login", { token, username, password });
}

// Save user data to localStorage
export function saveTokenInLocalStorage(userData) {
  localStorage.setItem("userDetails", JSON.stringify(userData));
  if (userData.role_id === "7") {
    //this case is only for doctor login
    localStorage.setItem("doctorId", userData.user_id);
  }
  console.log("User Data >> ", userData);
}

// Clear localStorage on logout
export function logout() {
  // localStorage.removeItem("userDetails");
  return axiosInstance.post("/admin/logout");
}

// Redirect based on login status
import { loginConfirmedAction } from "../store/actions/AuthActions";

export function checkAutoLogin(dispatch) {
  const userDetails = localStorage.getItem("userDetails");

  if (userDetails) {
    const parsed = JSON.parse(userDetails);

    // ✅ optional: if backend gives flag
    if (parsed.enable_2fa === "Yes" && !parsed.otp_verified) {
      return; // ❌ don't auto login
    }

    dispatch(loginConfirmedAction(parsed));
  }
}

export function verifyOtp(user_id, otp) {
  console.log("SERVICE admin_id:", user_id); // 🔥

  return axiosInstance.post("/admin/loginOTPVerify", {
    admin_id: user_id,
    otp,
  });
}
